// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"371":"976aae30","475":"8f869eb6","480":"8d735634","515":"5ceb39b6","631":"3ecfc7cf","948":"876943b4"}[chunkId] + ".chunk.css";
};